import React from 'react';

/* eslint-disable */
const TyPageModalBody = () => (
  <div className="modal-typage">
    <h3>CONOCE TU SEGURO</h3>
		<hr />
    <h2>Periodo de carencia</h2>
    <p>Es el tiempo inicial en el cual, de ser diagnosticado con una o más enfermedades, 
				estas no serán cubiertas durante todo el periodo de vigencia de la póliza, ni en sus renovaciones.</p>
		<ul className="list-disc">
			<li>El periodo de carencia de toda la póliza es de 30 días*</li>
			<li>Chequeo preventivo y Vacunas a partir de los 6 meses.</li>
			<li>Tu salud es importante para nosotros, por ello, con tu seguro Salud Flexible ponemos a 
				tu disposición desde el primer día estas coberturas: Emergencias accidentales (en caso hayas 
				contratado la cobertura adicional de Emergencias y Ambulancia), Videoconsulta y Orientación telefónica.</li>
		</ul>
		<h2>Periodo de espera</h2>		
		<p>Es el plazo inicial durante el cual determinadas coberturas no están activas. Culminado este periodo, se te 
			otorgarán dichas coberturas con normalidad. Si en caso hubieras contratado coberturas adicionales, ten en cuenta los siguientes periodos de espera:</p>
		<ul className="list-disc">
			<li>Odontología: 2 meses</li>
			<li>Maternidad: 18 meses</li>
			<li>Tratamiento o cirugía relacionado con enfermedades específicas: 10 meses (revisar diagnósticos en el plan de beneficios).</li>
		</ul>
		</div>
);

export default TyPageModalBody;